/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Autocomplete,
  Box,
  Grid,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import { ChipSelectList, DebouncedSearchInput } from '@marageti/z4-lib';
import {
  Option,
  AssigneeOption,
  TYPE_FILTER_OPTIONS,
  SORT_OPTIONS,
  STATUS_CHIPS,
  SEVERITY_CHIPS,
} from './options';

type TicketsFiltersProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  selectedTypes: Option[];
  onTypeChange: (event: any, values: Option[]) => void;
  assignees: AssigneeOption[];
  selectedAssignee: AssigneeOption;
  onAssigneeChange: (assignee: AssigneeOption | null) => void;
  sortValue: string;
  onSortChange: (sort: string) => void;
  selectedStatusChips: string[];
  onStatusChipChange: (chips: string[]) => void;
  selectedSeverityChips: string[];
  onSeverityChipChange: (chips: string[]) => void;
  isSeverityChipsDisabled: boolean;
};

const TicketsFilters = ({
  searchValue,
  onSearchChange,
  selectedTypes,
  onTypeChange,
  assignees,
  selectedAssignee,
  onAssigneeChange,
  sortValue,
  onSortChange,
  selectedStatusChips,
  onStatusChipChange,
  selectedSeverityChips,
  onSeverityChipChange,
  isSeverityChipsDisabled,
}: TicketsFiltersProps) => (
  <Box>
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid item xs={12} md={6} lg={3}>
        <DebouncedSearchInput
          fullWidth
          key="search"
          label="Search"
          name="search"
          onChange={onSearchChange}
          defaultValue={searchValue}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <Autocomplete
          multiple
          getOptionKey={(o) => o.value}
          getOptionLabel={(o) => o.title}
          id="type-filter"
          isOptionEqualToValue={(o, v) => o.value === v.value}
          onChange={onTypeChange}
          options={TYPE_FILTER_OPTIONS}
          renderInput={(params) => (
            <TextField {...params} label="Type" name="type" />
          )}
          value={selectedTypes}
          ChipProps={{
            size: 'small',
            sx: { bgcolor: 'common.warning10' },
          }}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <Autocomplete
          getOptionKey={(o) => o.value}
          getOptionLabel={(o) => o.title}
          groupBy={(o) => o.status || ''}
          id="assignee-filter"
          isOptionEqualToValue={(o, v) => o.value === v.value}
          onChange={(_, v) => onAssigneeChange(v)}
          options={assignees}
          renderInput={(params) => (
            <TextField {...params} label="Assignee" name="assignee" />
          )}
          value={selectedAssignee}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextField
          fullWidth
          key="sort-select"
          label="Sort by"
          name="sort"
          onChange={(e) => onSortChange(e.target.value)}
          select
          value={sortValue}
        >
          {SORT_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.title}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>

    <Stack direction={{ mobile: 'column', desktop: 'row' }} spacing={2} sx={{ mt: 1, mb: 4 }}>
      <ChipSelectList
        label="Status"
        chipOptions={STATUS_CHIPS}
        selectedChips={selectedStatusChips}
        onChange={onStatusChipChange}
      />
      <ChipSelectList
        label="Outcome"
        chipOptions={SEVERITY_CHIPS}
        selectedChips={selectedSeverityChips}
        onChange={onSeverityChipChange}
        chipProps={{
          disabled: isSeverityChipsDisabled,
        }}
      />
    </Stack>
  </Box>
);

export default TicketsFilters;
